import Vue from 'vue'
import App from './App.vue'
// import './assets/css/copycommon.css'
import './assets/css/common.css'
import './assets/css/fontfamily.css'
import VueRouter from 'vue-router'
import routerConfig from './router.config.js'
import Axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import global from './assets/components/commen.vue';
import store from './assets/components/store/index.js'

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

import BaiduMap from 'vue-baidu-map'

// import Video from 'video.js'
// import 'video.js/dist/video-js.css'
// Vue.prototype.$video = Video
 
Vue.use(BaiduMap, {
    ak: 'jNSWRxo2lah2tGQGcuFtGYMk6ITqeMhc'
});

Vue.use(VueRouter)
Vue.config.productionTip = false

Vue.prototype.$axios = Axios
// Axios.defaults.baseURL = '/api'
Axios.defaults.baseURL = '/sgapi'

Vue.use(ElementUI);
Vue.prototype.COMMON = global

const router = new VueRouter(routerConfig)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})




new Vue({
	router,
	store,
  render: h => h(App),
	mounted () {
		document.dispatchEvent(new Event('render-event'))
	}
}).$mount('#app')
